
<style src="./Home.scss" lang="scss" scoped></style>

<template>
  <div
    class="home overflow-hidden"
    @click = "closeModals($event)">
    <image-modal v-if="$store.getters.isImageModel || isAddNewImageModal"/>
    <shape-modal v-if="$store.getters.isShapeModel "/>
    <video-modal v-if="$store.getters.getDisplayAddVideoModal || this.$store.getters.getIsVideoModel"/>
    <audio-modal v-if="$store.getters.getDisplayAddAudioModal"/>
    <generic-modal/>
    <video-confirmation-modal
      v-if="getVideoConfirmationModel"
      :product="$refs.mainContent.product"/>
    <size-modal/>
    <crop-component v-if="$store.getters.getCrop.isEnable"/>
    <Header/>
    <main-content ref="mainContent"/>
    <qr-modal/>
  </div>
</template>
<script>
import CropComponent from '@/components/LeftSection/CropComponent';
import MainContent from '@/components/MainContent/MainContent.vue';
import Header from '@/components/Header/Header.vue';
import ImageModal from '@/components/ImageModal/ImageModal.vue';
import ShapeModal from '@/components/ShapeModel/ShapeModel.vue';
import GenericModal from '@/components/GenericModal/GenericModal.vue';
import AddSizeModal from '@/components/AddSizeModal/AddSizeModal.vue';
import { mapGetters } from 'vuex';
import AddQRCodeModal from '@/components/AddSizeModal/AddQRCodeModal';
import VideoConfirmationModal from '@/components/VideoConfirmationModal/VideoConfirmationModal.vue';
import AudioModal from '@/components/AudioModal/AudioModal';
import VideoModal from '../../components/VideoModal/VideoModal.vue';
import EventBus from '../../EventBus';

export default {
  name:       'Home',
  components: {
    Header,
    'main-content':             MainContent,
    'image-modal':              ImageModal,
    'shape-modal':              ShapeModal,
    'size-modal':               AddSizeModal,
    'qr-modal':                 AddQRCodeModal,
    'generic-modal':            GenericModal,
    'crop-component':           CropComponent,
    'video-modal':              VideoModal,
    'video-confirmation-modal': VideoConfirmationModal,
    'audio-modal':              AudioModal,
  },

  data() {
    return {
      checkModal: false,
    };
  },
  created() {
    if (document.URL.startsWith('https://www.cumarketingcenter.com') || document.URL.startsWith('http://www.cumarketingcenter.com') || document.URL.startsWith('https://dev2.wysiwyg.cumarketingcenter.com') || document.URL.startsWith('http://dev2.wysiwyg.cumarketingcenter.com') || document.URL.includes('www.cumarketingcenter.com')) {
      this.$store.commit('setBMCInstance', 'cumarketingcenter');
      this.$store.commit('setBaseUrl', '//dev2.wysiwyg.cumarketingcenter.com');
    } else if (document.URL.startsWith('https://www.marketingcenter.source4.com') || document.URL.startsWith('http://www.marketingcenter.source4.com') || document.URL.startsWith('https://dev2.wysiwyg.marketingcenter.source4.com') || document.URL.startsWith('http://dev2.wysiwyg.marketingcenter.source4.com') || document.URL.includes('www.marketingcenter.source4.com')) {
      this.$store.commit('setBMCInstance', 'marketingcenter.source4');
      this.$store.commit('setBaseUrl', '//dev2.wysiwyg.marketingcenter.source4.com');
    } else if (document.URL.startsWith('https://www.healthcaremarketingcenter.com') || document.URL.startsWith('http://www.healthcaremarketingcenter.com') || document.URL.startsWith('https://dev2.wysiwyg.healthcaremarketingcenter.com') || document.URL.startsWith('http://dev2.wysiwyg.healthcaremarketingcenter.com') || document.URL.includes('www.healthcaremarketingcenter.com')) {
      this.$store.commit('setBMCInstance', 'healthcaremarketingcenter');
      this.$store.commit('setBaseUrl', '//dev2.wysiwyg.healthcaremarketingcenter.com');
    }
  },


  computed: {
    ...mapGetters({
      isAddNewImageModal: 'getIsAddNewImageModal',
    }),
    getCropParentDivStyles() {
      return {
        zIndex:          1000,
        backgroundColor: 'rgba(0,0,0,0.7)',
      };
    },
    getVideoConfirmationModel() {
      return this.$store.getters['activeProduct/getVideoConfirmationModel'];
    },
  },
  methods: {
    cropImage() {
      this.$store.commit('updateCrop', { isEnable: false });
    },
    closeModals(e) {
      EventBus.$emit('modalsCloser', { checkModal: this.checkModal, e });
    },

  },
};

</script>
